export var MuiAccordion = {
    square: true,
    elevation: 0,
};
//# sourceMappingURL=MuiAccordion.js.map